import { useEffect, useRef } from "react";

/**
 * Держит переписку прокрученной к последнему сообщению, пока ответ печатается:
 * marker — то, что меняется по мере роста ответа.
 */
export function useScrollToLastMessage(marker: string | number) {
  const anchor = useRef<HTMLDivElement>(null);

  useEffect(() => {
    anchor.current?.scrollIntoView({ block: "end" });
  }, [marker]);

  return anchor;
}
